import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "./AuthProvider";
import { useSessionExpiry } from "./SessionExpiryContext";
import { ConsentModal } from "components/authentication/consent/ConsentModal";
import { useConsentStage } from "components/authentication/consent/consentStage";
export const ConsentGate = ({ element }) => {
  const { authenticated, loading } = useAuth();
  const { isShowingDialog } = useSessionExpiry();
  const stage = useConsentStage();

  if (loading) {
    return <div></div>;
  }

  if (isShowingDialog) {
    return element;
  }

  if (!authenticated) {
    return <Navigate to="/" />;
  }

  if (stage === "required") {
    return (
      <>
        {element}
        <ConsentModal />
      </>
    );
  }

  return element;
};
